import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import logoOuraTrust from "@/assets/logo-ouratrust-v2.png";
import { useLanguage } from "@/hooks/useLanguage";
import { localizePublicPath } from "@/lib/publicRoutes";

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white" aria-label="Site footer">
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to={localizePublicPath('/', language)}>
              <img src={logoOuraTrust} alt="OuraTrust" className="mb-4 h-7 object-contain brightness-0 invert" width={185} height={28} />
            </Link>
            <p className="max-w-sm text-sm text-slate-400">{t.footerTagline}</p>
            <p className="mt-4 flex items-center gap-1.5 text-xs font-bold text-primary">
              <Shield size={14} />
              {t.footerCompliance}
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">{t.resources}</h4>
            <ul className="space-y-2">
              <li><Link to={localizePublicPath('/how-it-works', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.footerHowItWorks}</Link></li>
              <li><Link to={localizePublicPath('/pricing', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.footerPricing}</Link></li>
              <li><Link to={localizePublicPath('/about', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.footerAbout}</Link></li>
              <li><Link to={localizePublicPath('/blog', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.blog}</Link></li>
              <li><Link to={localizePublicPath('/contact', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">{t.footerLegal}</h4>
            <ul className="space-y-2">
              <li><Link to={localizePublicPath('/privacy-policy', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.privacyPolicy}</Link></li>
              <li><Link to={localizePublicPath('/terms', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.termsOfService}</Link></li>
              <li><Link to={localizePublicPath('/legal-notice', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.legalMentions}</Link></li>
              <li><Link to={localizePublicPath('/data-deletion', language)} className="text-sm text-slate-400 transition-colors hover:text-white">{t.dataDeletion}</Link></li>
              <li><Link to={localizePublicPath('/google-data-usage', language)} className="text-sm text-slate-400 transition-colors hover:text-white">Google API Data Usage</Link></li>
            </ul>
          </div>
        </div>

        <div className="space-y-2 border-t border-slate-800 py-4 text-center">
          <p className="text-xs text-slate-500">{t.footerApiNotice}</p>
          <p className="mx-auto max-w-2xl text-[10px] text-slate-600">{t.footerComplianceDisclaimer}</p>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-4 md:flex-row">
          <span className="text-xs text-slate-500">{t.footerCopyright}</span>
          <p className="text-sm text-slate-400">{t.contact}: support@ouratrust.com</p>
        </div>
      </div>
    </footer>
  );
};
